// extracted by mini-css-extract-plugin
export default {"container":"select-label_container__PtKGG","noPadding":"select-label_noPadding__Y6iaW","showValue":"select-label_showValue__VTvBf","icon":"select-label_icon__7hhVY"};